export default {
  "content": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M8.696 6.64c.408-.46 1.112.188.685.638L7.344 9.464c-.168.165-.389.165-.553 0L4.459 7.306c-.46-.417.192-1.107.638-.685L6.57 7.977C6.472 4.731 4.004 2.108.983 2.108a.468.468 0 01-.47-.47c0-.262.212-.468.47-.468 3.518 0 6.404 3.002 6.526 6.742L8.696 6.64z\"/><path d=\"M14.5 3.145a.5.5 0 01.5.5v9.685a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V7.37a.5.5 0 00-1 0v5.96a1.5 1.5 0 001.5 1.5h13a1.5 1.5 0 001.5-1.5V3.645a1.5 1.5 0 00-1.5-1.5h-4.487a.5.5 0 000 1H14.5z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};